import {
  AiFieldFilter,
  AiFieldFilterType,
} from 'module/types/filter-field/filter';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';

export const toAiFilterFunction = (filter: AiFieldFilter): FilterFunction => {
  if (filter.type === AiFieldFilterType.Ai) {
    return (record) => record.value !== null;
  }

  return () => true;
};
